import {PreferenceFrequency, PreferenceType} from "../../services/preferenceTypes";
import {productsService} from "../../services/productsService";
import {RecipeCharacteristicCategory} from "../../services/recipeTypes";
import {propertiesService} from "../../services/propertiesService";
import {LOCALE_RU} from "../../constant";

export const findTranslationValue = (frequencyPeriod, i18n) => {
    if (i18n.resolvedLanguage === LOCALE_RU) {
        if (frequencyPeriod > 10 && [11, 12, 13, 14].includes(frequencyPeriod % 100)) return 'дней';
        let last_num = frequencyPeriod % 10;
        if (last_num === 1) return 'день';
        if ([2, 3, 4].includes(last_num)) return 'дня';
        if ([5, 6, 7, 8, 9, 0].includes(last_num)) return 'дней';
    } else {
        return 'days';
    }
};

const findFrequencyPeriodValue = (preferenceFrequency, frequencyPeriod) => {
    if(preferenceFrequency === PreferenceFrequency.NO_MATTER) {
        return PreferenceFrequency.NO_MATTER;
    }
    if(preferenceFrequency === PreferenceFrequency.ONCE_A_PERIOD && frequencyPeriod === 1) {
        return PreferenceFrequency.EVERY_DAY;
    }
    if(preferenceFrequency === PreferenceFrequency.ONCE_A_PERIOD && frequencyPeriod === 2) {
        return PreferenceFrequency.DAY_AFTER_DAY;
    }
    if (frequencyPeriod > 2) {
        return PreferenceFrequency.ONCE_IN_DAYS;
    }
};

export const findFrequencyTitle = (preferenceFrequency, frequencyPeriod, i18n) => {
    if(+frequencyPeriod > 2 && preferenceFrequency === PreferenceFrequency.ONCE_A_PERIOD) {
        return i18n.t(`preference.scheme.frequency.${findFrequencyPeriodValue(preferenceFrequency, frequencyPeriod)}`)
            + ` ${frequencyPeriod} ${findTranslationValue(frequencyPeriod, i18n)}`;
    } else {
        return i18n.t(`preference.scheme.frequency.${findFrequencyPeriodValue(preferenceFrequency, frequencyPeriod)}`);
    }
};

const getCodesList = (preferenceType, preferenceItemCodes, i18n) => {
    const result = [];
    for(let code of preferenceItemCodes) {
        if(preferenceType === PreferenceType.PRODUCT ) {
            result.push(productsService.getLocalization(i18n.resolvedLanguage, code.itemCode, true));
        } else if (preferenceType === PreferenceType.PRODUCT_CATEGORY_PER_MEAL || preferenceType === PreferenceType.PRODUCT_CATEGORY_PER_DAY) {
            let itemCode = i18n.t(`product.scheme.formGroup.${code.itemCode.toLowerCase()}`);
            if (code.minValue !== null && code.minValue !== undefined && code.maxValue !== null && code.maxValue !== undefined) {
                itemCode += `: ${code.minValue}-${code.maxValue} `;
            }
            if (code.value !== null && code.value !== undefined) {
                itemCode += i18n.t(`meal.scheme.unit.${code.value}`);
            }
            result.push(itemCode);
        } else if (preferenceType === PreferenceType.CEREAL_MIX) {
            result.push(productsService.getLocalization(i18n.resolvedLanguage, code.itemCode, true));
        } else if(preferenceType === PreferenceType.RECIPE) {
            result.push(i18n.t(`recipe.scheme.recipeType.${code.itemCode}`));
        } else if(preferenceType === PreferenceType.RECIPE_CHARACTERISTIC) {
            let itemCode =  i18n.t(`app.page.recipe.recipeCharacteristic.${code.itemCode}`) + ", ";
            if (code.itemCode === RecipeCharacteristicCategory.RECIPE_CHARACTERISTIC_PRODUCT_CATEGORY) {
                itemCode += i18n.t(`product.scheme.formGroup.${code.value}`);
            } else {
                itemCode += i18n.t(`recipe.scheme.characteristic.${code.itemCode}.${code.value}`);
            }
            result.push(itemCode);
        } else if (preferenceType === PreferenceType.KASHA_CONSISTENCY) {
            result.push(i18n.t(`preference.scheme.preferenceItem.${code.itemCode}`));
        } else if(preferenceType === PreferenceType.PROPERTY || preferenceType === PreferenceType.MACRONUTRIENT_PER_DAY || preferenceType === PreferenceType.MACRONUTRIENT_PER_MEAL) {
            let itemCode = propertiesService.getLocalization(i18n.resolvedLanguage, code.itemCode, true);
            itemCode += `: ${code.minValue}-${code.maxValue} `;
            itemCode += i18n.t(`meal.scheme.unit.${code.value}`);
            if (code.value === 'g-per-kg') {
                const minG = code.minValue != null ? Number(code.minValue) * 60 : null;
                const maxG = code.maxValue != null ? Number(code.maxValue) * 60 : null;
                if (minG != null && !Number.isNaN(minG)) {
                    const maxPart = maxG != null && !Number.isNaN(maxG) ? `–${maxG}` : '';
                    itemCode += ` (≈ ${minG}${maxPart} ${i18n.t('meal.scheme.unit.gram')} @ 60 kg)`;
                }
            }
            result.push(itemCode);
        }
    }
    return result;
};

export const createPreferenceItemCodesValue = (preference, i18n) => {
    if(preference.preferenceType !== PreferenceType.COMBINATION && preference.preferenceItemCodes && preference.preferenceItemCodes.length) {
        const result = getCodesList(preference.preferenceType, preference.preferenceItemCodes, i18n);
        const codes = result.join(', ');
        return preference.layerCode ? `[${preference.layerCode}] ${codes}` : codes;
    }
    if(preference.preferenceType === PreferenceType.COMBINATION) {
        const result = [];
        for(let child of preference.combinedPreferences) {
            result.push(...getCodesList(child.preferenceType, child.preferenceItemCodes, i18n));
        }
        return result.join(', ');
    }
    return '';
};

export const createValuesString = (phrase, i18n) => {
    return [
        i18n.t(`preference.scheme.include.${phrase.include}`),
        i18n.t(`preference.scheme.preferenceType.${phrase.preferenceType}`),
        createPreferenceItemCodesValue(phrase, i18n),
        i18n.t(`preference.scheme.when.${phrase.when}`),
        findFrequencyTitle(phrase.preferenceFrequency, +phrase.frequencyPeriod, i18n),
    ].join(' | ');
};
